export default __webpack_public_path__ + "static/media/JohnGao.29cab750.jpeg";